import { css } from '@emotion/react';
import theme from '../../../styles/theme';

export const styles = {
  teamsWrapper: css``,
  teamsHeaderWrapper: css`
    padding: 50px 0 24px 50px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      padding: 70px 70px 0 70px;
    }

    @media (min-width: ${theme.breakpoints.values.xl}px) {
      padding: 70px 140px 0;
    }

    & > h5 {
      width: 100%;
      border-bottom: 1px solid ${theme.palette.primary.main};
      text-transform: uppercase;
      color: ${theme.palette.primary.main};
      margin-bottom: 58px;
    }

    & > h2 {
      color: ${theme.palette.primary.main};
    }
  `,
  teamsContainer: css`
    padding: 0 50px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      padding: 58px 70px 0;
    }

    @media (min-width: ${theme.breakpoints.values.xl}px) {
      padding: 58px 140px 0;
    }
  `,
  teamContainer: css`
    flex: 1;
    padding: 12px 0;

    & > h3 {
      margin-top: 40px;
    }

    & > p {
      margin-top: 24px;
    }

    &:last-child {
      padding-bottom: 0;

      @media (min-width: ${theme.breakpoints.values.md}px) {
        padding-bottom: 12px;
      }
    }

    @media (min-width: ${theme.breakpoints.values.md}px) {
      padding: 12px;
    }
  `,
  teamImageContainer: css`
    width: 100%;
    display: flex;
    justify-content: center;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      width: unset;
      display: unset;
    }
  `,
  technologiesWeOfferWrapper: css`
    padding: 64px 0 0;
    width: 100%;
    position: relative;

    & > h2 {
      right: 70px;
      top: 128px;
      color: ${theme.palette.primary.main};
      padding: 0 70px 0;
      margin-bottom: 20px;

      @media (min-width: ${theme.breakpoints.values.md}px) {
        padding: 0;
      }

      @media (min-width: ${theme.breakpoints.values.lg}px) {
        position: absolute;
      }

      @media (min-width: 1520px) {
        left: 924px;
        right: 60px;
        white-space: nowrap;
      }
    }

    @media (min-width: ${theme.breakpoints.values.md}px) {
      padding: 64px 50px 0;
    }

    @media (min-width: ${theme.breakpoints.values.xl}px) {
      padding: 64px 140px 0;
    }
  `,
  technologiesWeOfferContainer: css`
    display: flex;
    flex-direction: column;
    gap: 48px;

    & > img {
      object-fit: cover;
      object-position: center;
      width: 100%;
      max-width: 721px;

      @media (min-width: ${theme.breakpoints.values.lg}px) {
        width: calc(100% - 364px);
      }
    }

    & > p {
      font: normal normal 300 14px/20px Outfit;
      margin-top: 0px;
      padding: 0 50px 0;

      @media (min-width: ${theme.breakpoints.values.sm}px) {
      }

      @media (min-width: ${theme.breakpoints.values.md}px) {
        /*padding: 0;*/
      }

      @media (min-width: ${theme.breakpoints.values.lg}px) {
        margin-top: 164px;
      }
    }

    @media (min-width: ${theme.breakpoints.values.lg}px) {
      gap: 64px;
      flex-direction: row;
    }
  `,
  technologiesGroupWrapper: css`
    display: flex;
    padding: 44px 50px 0;

    @media (min-width: ${theme.breakpoints.values.xl}px) {
      padding: 64px 140px 0;
    }
  `,
  technologiesGroupNamesWrapper: css`
    width: 100%;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
      flex: 1;
      margin-right: 48px;
    }
  `,
  technologiesGroupName: css`
    width: 100%;
    cursor: pointer;
    font: normal normal 300 24px/30px Outfit;
    color: ${theme.palette.text.primary};
    border-bottom: 1px solid transparent;
    transition:
      color 0.3s ease-in-out,
      border-bottom-color 0.3s ease-in-out;
    padding: 8px 0;
    margin: 8px 0;

    @media (min-width: ${theme.breakpoints.values.lg}px) {
      margin: 0;
    }
  `,
  technologiesGroupNameSelected: css`
    color: ${theme.palette.secondary.main};
    border-bottom: 1px solid ${theme.palette.secondary.main};
  `,
  technologiesGroupNameHovered: css`
    color: ${theme.palette.secondary.main};
    border-bottom: 1px solid ${theme.palette.secondary.main};
  `,
  technologiesGroupNameClickable: css`
    display: inline-block;
    width: 100%;
    cursor: pointer;

    @media (min-width: ${theme.breakpoints.values.lg}px) {
      cursor: default;
      pointer-events: none;
    }
  `,
  technologiesWrapper: css`
    display: none;

    @media (min-width: ${theme.breakpoints.values.lg}px) {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      max-width: 50%;
      gap: 32px;
      align-content: flex-start;
      min-height: 550px;
      position: relative;
      transition: opacity 0.2s ease-in-out;
    }
  `,
  technologyWrapper: css`
    width: 150px;
    height: 150px;
    min-width: 150px;
    border-radius: 50%;
    border: 1px solid ${theme.palette.primary.main};
    font: normal normal 600 14px/20px Outfit;
    color: ${theme.palette.primary.main};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    text-align: center;
    opacity: 0;
    transform: translateY(15px) scale(0.95);
    animation: fadeInSlideUp 0.3s ease-out forwards;
    transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
    background-color: transparent;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);

    @keyframes fadeInSlideUp {
      from {
        opacity: 0;
        transform: translateY(15px) scale(0.95);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    &:hover {
      transform: translateY(0) scale(1.12) rotate(3deg);
      border-width: 2px;
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
    }

    &:nth-of-type(1) {
      animation-delay: 0s;
    }
    &:nth-of-type(2) {
      animation-delay: 0.03s;
    }
    &:nth-of-type(3) {
      animation-delay: 0.06s;
    }
    &:nth-of-type(4) {
      animation-delay: 0.09s;
    }
    &:nth-of-type(5) {
      animation-delay: 0.12s;
    }
    &:nth-of-type(6) {
      animation-delay: 0.15s;
    }
    &:nth-of-type(7) {
      animation-delay: 0.18s;
    }
    &:nth-of-type(8) {
      animation-delay: 0.21s;
    }
    &:nth-of-type(9) {
      animation-delay: 0.24s;
    }
    &:nth-of-type(10) {
      animation-delay: 0.27s;
    }
    &:nth-of-type(11) {
      animation-delay: 0.3s;
    }
    &:nth-of-type(12) {
      animation-delay: 0.33s;
    }
  `,

  technologiesSmallWrapper: css`
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    width: 100%;
    padding: 32px 0;
    transition:
      opacity 0.2s linear,
      transform 0.2s linear;

    @media (min-width: ${theme.breakpoints.values.lg}px) {
      display: none;
    }
  `,
  technologySmallWrapper: css`
    width: 110px;
    height: 110px;
    min-width: 110px;
    border-radius: 50%;
    border: 1px solid ${theme.palette.primary.main};
    font: normal normal 600 14px/20px Outfit;
    color: ${theme.palette.primary.main};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    text-align: center;

    @media (min-width: ${theme.breakpoints.values.lg}px) {
      width: 150px;
      height: 150px;
      min-width: 150px;
      padding: 16px;
      transition:
        opacity 0.2s linear,
        transform 0.2s linear;
    }
  `,
  technologiesWrapperFadeOut: css`
    opacity: 0;
  `,
};
